import { IPage, IProfile } from '../../Models/Security';

export enum Actions {
	REQUESTING_PROFILE = 'REQUESTING_PROFILE',
	FETCH_PROFILE_LIST = 'FETCH_PROFILE_LIST',
	FETCH_PROFILE = 'FETCH_PROFILE'
}

export interface IActionFetchProfileList {
	type: Actions.FETCH_PROFILE_LIST;
	payload: IPage<IProfile>;
}

export interface IActionFetchProfile {
	type: Actions.FETCH_PROFILE;
	payload: IProfile;
}

export interface IActionRequestingProfile {
	type: Actions.REQUESTING_PROFILE;
}
